<template>
    <transition name="fade">
        <div class="patient-coaching-summary-habits">

            <div class="float-right">
                <my-habits-edit-modal :habits="habits"
                                      v-if="showEditLinks">
                </my-habits-edit-modal>
            </div>

            <b-row cols="3">
                <b-col class="text-center"
                       v-for="(h, index) in visibleHabits" :key="index">
                    <my-habits-chart-motivation class="mr-2 mb-2" style="display:inline-block"
                                                :participant-id="participant.id"
                                                :habit="h"
                                                :index="index">
                    </my-habits-chart-motivation>
                    <my-habits-chart-progress class="mr-2 mb-2" style="display:inline-block"
                                              :participant-id="participant.id"
                                              :habit="h"
                                              :index="index">
                    </my-habits-chart-progress>
                    <br/>
                    <div class="mb-2">
                        {{ h.habit }}
                    </div>

                    <my-habits-edit-modal v-if="showEditLinks"
                                          :habits="habits"
                                          :habit="h"
                                          :index="index">
                    </my-habits-edit-modal>
                </b-col>
            </b-row>

        </div>
    </transition>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'

export default Vue.extend({
    name: 'PatientCoachingSummaryHabits',
    props: {
        showEditLinks: {type: Boolean, default: false }
    },
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        habits() {
            return this.participant.wellness_plan ? this.participant.wellness_plan.habits : []
        },
        visibleHabits() {
            return _.filter(this.habits, (habit) => {
                return !habit.archivedTimestamp
            })
        },
    }
})
</script>
